import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FinanceProductType } from '../../api/types';

const useStaticFinanceProductType = (countryCode?: string) => {
    const { t } = useTranslation(['financeProductDetails']);

    return useMemo(() => {
        const isTaiwan = countryCode && countryCode === 'TW';
        const financeProductTypeOptions = [
            {
                key: FinanceProductType.HirePurchase,
                title: t('financeProductDetails:transferFields.financeHirePurchase'),
            },
            {
                key: FinanceProductType.HirePurchaseWithBalloon,
                title: t('financeProductDetails:transferFields.financeHirePurchaseWithBalloon'),
            },
            {
                key: FinanceProductType.HirePurchaseWithBalloonGfv,
                title: t('financeProductDetails:transferFields.hirePurchaseWithBalloonGFV'),
            },
            {
                key: FinanceProductType.DeferredPrincipal,
                title: t('financeProductDetails:transferFields.financeDeferredPrincipal'),
            },
            {
                key: FinanceProductType.Lease,
                title: t('financeProductDetails:transferFields.leasing'),
            },
            {
                key: FinanceProductType.LeasePurchase,
                title: t('financeProductDetails:transferFields.leasePurchase'),
            },
        ];
        if (isTaiwan) {
            financeProductTypeOptions.push({
                key: FinanceProductType.UcclLeasing,
                title: t('financeProductDetails:transferFields.ucclLeasing'),
            });
        }

        return { financeProductTypeOptions };
    }, [countryCode, t]);
};

export default useStaticFinanceProductType;
